import React from 'react';

interface SplitterProps {
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

export const Splitter: React.FC<SplitterProps> = ({ orientation = 'vertical', className = '' }) => (
  <div className={`bg-dark-bg flex items-center justify-center ${orientation === 'vertical' ? 'w-1 cursor-col-resize' : 'h-1 cursor-row-resize'} hover:bg-brand-500 transition-all duration-150 opacity-50 hover:opacity-100 shrink-0 ${className}`}>
    <div className={`bg-dark-border rounded-full ${orientation === 'vertical' ? 'w-0.5 h-4' : 'w-4 h-0.5'}`} />
  </div>
);
